import { memo } from 'react';
import { useSelector } from 'react-redux';

import { type AssetCustomFieldValue } from '@air/api/types';

import { useCurrentClipPermissions } from '~/components/PrivateAssetModal/hooks/useCurrentClipPermissions';
import { centralizedClipAssetIdSelector } from '~/store/centralizedClip/selectors';
import { canChangeAssetCustomFields } from '~/utils/permissions/assetPermissions';
import { PrivateAssetCustomFieldSelect } from './PrivateAssetCustomFieldSelect';
import { PrivateAssetPanelCustomFieldContainer } from './PrivateAssetPanelCustomFieldContainer';

export type PrivateAssetPanelCustomFieldSelectProps = {
  field: AssetCustomFieldValue;
};

export const PrivateAssetPanelCustomFieldSelect = memo(({ field }: PrivateAssetPanelCustomFieldSelectProps) => {
  const assetId = useSelector(centralizedClipAssetIdSelector);
  const { clipPermissions } = useCurrentClipPermissions();
  const canEditCustomFields = canChangeAssetCustomFields(clipPermissions);

  return (
    <PrivateAssetPanelCustomFieldContainer field={field}>
      <PrivateAssetCustomFieldSelect
        field={field}
        trackingLocation="asset-details"
        canEditCustomFields={canEditCustomFields}
        assetId={assetId}
      />
    </PrivateAssetPanelCustomFieldContainer>
  );
});

PrivateAssetPanelCustomFieldSelect.displayName = 'PrivateAssetPanelCustomFieldSelect';
